import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import ReportsFilter from '../../../main/reports/reportsFilter';
import { getProductInventoryActionFilters } from '../../../main/reports/selectors';
import { updateProductInventoryActionFilter } from '../../../main/reports/actions';

const ProductInventoryActionFilter = ({ updateFilter, productInventoryActionFilters, allChecked }) => (
  <div className="c-form-input-group__item">
    <ReportsFilter
      title="Action"
      filters={productInventoryActionFilters}
      updateStatusViewed={updateFilter}
      showSelectAll
      allChecked={allChecked}
    />
  </div>
);

ProductInventoryActionFilter.propTypes = {
  updateFilter: PropTypes.func.isRequired,
  productInventoryActionFilters: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  productInventoryActionFilters: getProductInventoryActionFilters(state),
});

const mapDispatchToProps = {
  updateFilter: updateProductInventoryActionFilter,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    allChecked: props.productInventoryActionFilters.every(f => f.checked),
  })),
)(ProductInventoryActionFilter);
